<template>
    <div class="app-space" :style="{'height' : spaceHeight}">
    </div>
</template>

<script>


export default {
    name: 'AppTopSpace.vue',
    data() {
        return {
            from: '',
            spaceHeight: '70px',
        };
    },
    mounted() {
        this.from = localStorage.getItem('from');
        if (this.from === 'android_box') {
            this.spaceHeight = '110px';
        }
    },
    methods: {
    }
};
</script>

<style scoped>
    .app-space {
        display: none;
    }

    @media screen and (max-width: 900px) {
        .app-space {
            display: flex;
        }
    }
</style>